import { Directive } from "@angular/core";

@Directive({
  standalone: true,
  selector: "[appFullWidth]",
  host: { style: "display:flex;width:100%" },
})
export class FullWidthDirective {}
